<script>
import { DEFAULT_CURRENT_PAGE, DEFAULT_PAGE_SIZE } from '@src/mixins/pagination'

export default {
  props: {
    currentPage: {
      type: Number,
      default: DEFAULT_CURRENT_PAGE,
    },
  },
  data() {
    return {
      total: 0,
      pageSize: DEFAULT_PAGE_SIZE,
    }
  },

  methods: {
    updateTotal(total) {
      this.total = total
    },
    updateCurrentPage(page) {
      this.$emit('update:currentPage', page)
    },
  },
}
</script>

<template>
  <el-pagination
    :class="$style.wrapper"
    :current-page="currentPage"
    :page-size="pageSize"
    :total="total"
    layout="prev, pager, next, jumper"
    background
    hide-on-single-page
    @current-change="updateCurrentPage"
  ></el-pagination>
</template>

<style lang="scss" module>
@import '@design';
.wrapper {
  margin-top: 15px;
  text-align: center;
}
</style>
